<!-- https://8es9hr.axshare.com/#g=1&p=%E7%8F%BE%E9%87%91_%E9%8A%80%E8%A1%8C%E5%AD%98%E6%AC%BE%E6%97%A5%E5%A0%B1%E8%A1%A8 -->
<!-- 現金_銀行存款日報表 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api="AssnUser"
                labelPosition="top"
                formTitle="現金/銀行存款日報表"
                :recordToEdit="recordToEdit"
                :formType="formType"
            >
                <div slot="footer">
                    <el-button type="primary" @click="print">查詢</el-button>
                </div>
            </ListForm>
            <div class="show-container">
                <div class="show"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";
export default {
    components: { ListForm },
    name: "CashBankDailyReport",
    data() {
        return {
            data: [],
            recordToEdit: {},
            show: false,
            date: "",
            type: "",
            recordToEdit: {},
            formType: [
                {
                    label: "查詢日期",
                    key: "date",
                    type: "date"
                },
                {
                    label: "報表種類",
                    key: "type",
                    type: "radio",
                    options: [
                        {
                            label: "現金",
                            value: 0
                        },
                        {
                            label: "銀行存款",
                            value: 1
                        }
                    ]
                }
            ]
        };
    },
    created() {},
    methods: {
        print() {
            const url = API.CoopAccReport;
            // get 參數
            let date =
                parseInt(
                    $(`.date`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.date`)
                    .val()
                    .slice(3);
            let type = type;
            const params = {
                action: "BankDepositDailyReportPdf",
                date: date || "",
                type: this.recordToEdit.type
            };
            this.mIframePDF(url, params);
        }
    }
};
</script>
<style lang="scss" scoped>
</style>